// Browser download without a dependency; returns false where object URLs are unavailable (tests, old WebViews).
export const downloadTextFile = (fileName, text, type = 'text/csv;charset=utf-8') => {
	if (typeof window === 'undefined' || typeof URL?.createObjectURL !== 'function') return false
	const url = URL.createObjectURL(new Blob([text], { type }))
	const anchor = document.createElement('a')
	anchor.href = url
	anchor.download = fileName
	document.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
	URL.revokeObjectURL(url)
	return true
}
